var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"slider",staticClass:"slider"},[_c('div',{ref:"sliderGroup",staticClass:"slider-group"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"dots"},_vm._l((_vm.dots),function(item,index){return _c('span',{key:index,staticClass:"dot",class:{active: _vm.currentPageIndex === index }})}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b1c2352","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base/slider/slider.vue
// module id = null
// module chunks = 